<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24" v-if="JSON.stringify(meterRepair)!='{}'">
              <a-divider orientation="left">{{ $t('报修信息') }}</a-divider>
              <detail-list>
                <detail-list-item :term="$t('报修人名称')">{{meterRepair.repairName}}</detail-list-item>
                <detail-list-item :term="$t('报修人电话')">{{meterRepair.repairPhone}}</detail-list-item>
                <detail-list-item :term="$t('报修地址')">{{meterRepair.repairAddress}}</detail-list-item>
                <detail-list-item :term="$t('报修时间')">{{meterRepair.repairTime}}</detail-list-item>
                <detail-list-item :term="$t('是否解决')">{{meterRepair.isSolve==0?$t('已解决'):$t('未解决')}}</detail-list-item>
                <detail-list-item :term="$t('报修描述')" :itemCol="1">{{meterRepair.repairDescription}}</detail-list-item>
              </detail-list>
              <div style="color: #999;">
                {{ $t('报修图片:') }}
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="fileList" :disabled="true"></j-image-upload>
              </div>
              <a-divider orientation="left">{{ $t('处理信息') }}</a-divider>
              <detail-list :col="3">
                <detail-list-item :term="$t('处理人员名称')">{{meterRepair.handleUserRealName}}</detail-list-item>
                <detail-list-item :term="$t('处理人员账号')">{{meterRepair.handleUserName}}</detail-list-item>
                <detail-list-item :term="$t('处理人员电话')">{{meterRepair.handleUserPhone}}</detail-list-item>
                <detail-list-item :term="$t('处理人员描述')" :itemCol="1">{{meterRepair.handleUserDescription}}</detail-list-item>
              </detail-list>
              <!-- <div style="color: #999;">
                修理图片:
                <j-image-upload class="avatar-uploader" text="上传" :isMultiple="true" v-model="fileList1" :disabled="true"></j-image-upload>
              </div> -->
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('是否归档')" prop="audit">
                <a-radio-group v-model="model.audit">
                  <a-radio :value="1">{{ $t('是') }}</a-radio>
                  <a-radio :value="0">{{ $t('否') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="8" v-if="model.audit == 0">
              <a-form-model-item label="是否结束" prop="isEnd">
                <a-radio-group v-model="model.isEnd">
                  <a-radio :value="1">是</a-radio>
                  <a-radio :value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col> -->
            <!-- <a-col :span="8" v-if="model.isEnd == 0">
              <a-form-model-item label="驳回处理人" prop="candidateUsers">
                <a-select mode="multiple" placeholder="请选择人员" v-model="model.candidateUsers">
                  <a-select-option :value="item.username" v-for="item in personnelList">{{item.realname}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col> -->
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import {PhoneNumberPattern} from '@/utils/regPattern'
  export default {
    // mixins: [JeecgListMixin],
    name: 'auditModal',
    components: {
      DetailList,
      DetailListItem,
      JImageUpload
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          queryById: "/jeecg-engineering/ticket/tickets/queryById",
          edit: "/jeecg-engineering/engineering/meterRepair/edit",
          userList: "/sys/user/list",
        },
        personnelList: [],
        meterRepair:{},
        fileList:'',
        fileList1:''
      }
    },
    computed: {
      validatorRules() {
        return {
          audit:{ required: true,message: this.$t('请选择是否归档'), trigger: 'change' },
          isEnd:{ required: true,message: this.$t('请选择是否结束'), trigger: 'change' },
          remark:{ required: !(this.model.audit == 1),message: this.$t('请输入备注'), trigger: 'input' },
          // candidateUsers:{ required: true,message: '请选择人员', trigger: 'change' },
        }
      },
    },
    methods: {
      getPersonnelList(){
        this.personnelList = [];
        getAction(this.url.userList,{status:1,pageSize:999}).then(res=>{
          if(res.success){
            this.personnelList = res.result.records
          }
        });
      },
      init(row){
        this.title = this.$t('归档');
        this.visible = true;
        this.model = {};
        this.model.id = row.id;
        this.model.ticketsType = row.ticketsType;
        this.model.ticketsId = row.id;
        // this.getPersonnelList();
        getAction(this.url.queryById,{id:row.id}).then(res=>{
          if(res.success){
            this.model.ticketsState = res.result.ticketsState;
            this.meterRepair = Object.assign({},res.result.wechatMeterRepair);
            this.$nextTick(()=>{
              if(res.result.wechatMeterRepair.source == 1){
                var arr = JSON.parse(res.result.wechatMeterRepair.repairPicture);
                this.$set(this,'fileList',arr.join(','));
              }else{
                this.$set(this,'fileList',res.result.wechatMeterRepair.repairPicture);
              }
            })
          }
        })
        
      },
      handleCancel() {
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            var url = ''
            if(this.model.audit == 1){
              url = that.url.pass;
            }else{
              url = that.url.reject;
            }
            let params = {
              dataId: that.model.id,
              values: {
                dataId: that.model.id,
              },
              comment: that.model.remark ? that.model.remark:''
            }
            postAction(url,params).then((res) => {
              if (res.success) {
                that.$message.success(this.$t('操作成功'));
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }else{
            this.$message.warning(this.$t('存在必填内容未填！'))
          }
        })
      },
    }
  }
</script>